var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-automation-list" },
    [
      _c("h3", { staticClass: "title" }, [_vm._v("Automations")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("a-input-search", {
                  staticClass: "row search-input",
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: _vm.$t("message.startFilter") },
                  on: {
                    input: function ($event) {
                      return _vm.onSearch($event.target.value)
                    },
                  },
                  model: {
                    value: _vm.searchText,
                    callback: function ($$v) {
                      _vm.searchText = $$v
                    },
                    expression: "searchText",
                  },
                }),
                _vm._v(" "),
                _c("CommonFilterTool", {
                  attrs: {
                    "keep-state-on-query-params": false,
                    "filter-meta": _vm.filterMetas,
                    "label-formatter": _vm.filterLabelFormatter,
                  },
                  on: { addFilter: _vm.addFilter },
                  model: {
                    value: _vm.breakdownFilter,
                    callback: function ($$v) {
                      _vm.breakdownFilter = $$v
                    },
                    expression: "breakdownFilter",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", disabled: _vm.loading },
                    on: { click: _vm.createEmptyTimerAutomation },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    Create Timer Automation\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "" },
                    on: { click: _vm.showEventAutomationModal },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    Create Event Based Automation\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "" },
                    on: { click: _vm.showWebhookAutomationModal },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    Create Webhook Automation\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.items,
              "top-pagination": "",
              "empty-data-bordered": "",
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                checkboxOption: _vm.checkboxOption,
                rowStyleOption: _vm.rowStyleOption,
                clipboardOption: _vm.clipboardOption,
                fixedHeader: true,
                id: "automation-table",
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.eventAutomationModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Create an Event Automation",
                "show-title": "",
                "show-footer": false,
                "class-name": "event-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.eventAutomationModalVisible = false
                },
              },
            },
            [
              _c("EventSelector", {
                on: { save: _vm.createEmptyEventAutomation },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.webhookAutomationFormModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Catch a Webhook And Run an Automation",
                "show-title": "",
                "show-footer": false,
                "class-name": "event-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.webhookAutomationFormModalVisible = false
                },
              },
            },
            [
              _c("WebhookAutomationForm", {
                on: { save: _vm.createWebhookAutomation },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }